import React, { Component } from "react";
import Slider from "react-slick";
import './Slider.css';

// custome function to hide the slider arrow buttons.
function SampleNextArrow(props){
    return (
        <div
            style={{display: "none",}}
        />
    );
}

function SamplePrevArrow(props) {
    return (
        <div
            style={{display: "none",}}
        />
    );
};

class OverviewSlider extends Component {
    render() {
        var settings = {
            dots: false,
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            autoplay: true,
            vertical: false,
            autoplaySpeed: 3000,
            cssEase: "linear",
            nextArrow: <SampleNextArrow />,
            prevArrow: <SamplePrevArrow />
        };
        const data = this.props.data;
        const listItems = data.map(flashes => {
            return flashes.slider
                .map((subItem, i) => {
                    return (
                       <div style={{linHeight: '100px'}}><h3 key={i}>{subItem}</h3></div>
                    )
                })
        } );


        // console.log(listItems)

        return (
                <Slider {...settings}>
                    {listItems}
                </Slider>

        );
    }
};

export default OverviewSlider;


// WEBPACK FOOTER //
// ./src/Containers/Slider/Slider.js